// extracted by mini-css-extract-plugin
export default {"title":"WebExhibits_title__qiwyR"};